import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { CTALink } from '@components/CTALink';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Label2, MediumBoldTextStyles, MediumTextStyles } from '@components/typography/interVariants';

export const AVATAR_SIZE = 71;
const NAME_WIDTH = 200;
const CTA_LINK_WIDTH = 120;
const CTA_LINK_WIDTH_MOBILE = 100;
const LINK_WRAPPER_WIDTH = 234;
const LINK_WRAPPER_WIDTH_MOBILE = 159;

export const ListItemWrapper = styled(Box)<{ showBorderBottoom: boolean }>`
  column-gap: ${themeSpace(8)};
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: ${({ showBorderBottoom }) => (showBorderBottoom ? '1px' : '0px')} solid ${themeColor('mono4')};
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    align-items: flex-start;
  }
  ${themeMediaQuery('sm')} {
    column-gap: ${themeSpace(6)};
  }
  ${themeMediaQuery('md')} {
    column-gap: ${themeSpace(8)};
  }
`;

export const AvatarImageContainer = styled(Box)`
  height: ${AVATAR_SIZE}px;
  width: ${AVATAR_SIZE}px;
`;

export const StyledCoupleAvatar = styled.img`
  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  object-fit: cover;
  border-radius: 50%;
`;

export const EventTypeField = styled(Text)`
  ${Label2};
  text-transform: capitalize;
`;

export const NameField = styled(Text)`
  ${MediumBoldTextStyles};
  padding-right: ${themeSpace(5)};
  cursor: pointer;
  &:hover {
    color: ${themeColor('linkHover')};
  }
  &:active {
    color: ${themeColor('linkPress')};
  }
  ${themeMediaQuery('sm')} {
    width: ${NAME_WIDTH}px;
  }
`;

export const DetailField = styled(Flex)`
  width: auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DetailFieldMobile = styled(DetailField)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: flex;
    width: 100%;
    gap: ${themeSpace(3)};
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const DateField = styled(Text)`
  ${MediumTextStyles};
  width: ${NAME_WIDTH}px;
  text-align: left;
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
    padding-top: ${themeSpace(1)};
  }
`;

export const DateFieldMobile = styled(DateField)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    padding-top: ${themeSpace(1)};
  }
`;

export const LinksWrapper = styled(Box)`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: ${LINK_WRAPPER_WIDTH}px;

  ${themeMediaQuery('below_sm')} {
    min-width: ${LINK_WRAPPER_WIDTH_MOBILE}px;
    padding-left: ${themeSpace(0)};
    padding-right: ${themeSpace(0)};
    a {
      padding-left: ${themeSpace(0)};
      padding-right: ${themeSpace(0)};
    }
  }
`;

export const StyledCTALink = styled(CTALink)`
  color: ${themeColor('mono1')};
  min-width: ${CTA_LINK_WIDTH_MOBILE}px;
  ${themeMediaQuery('sm')} {
    min-width: ${CTA_LINK_WIDTH}px;
  }
`;
